<template>
    <companies-tab></companies-tab>
</template>

<script>
export default {
    props: ["auth", "origin"],

    data() {
        return {
            total_companies: 0,
            total_employees: 0
        };
    },

    computed: {
        totalCompaniesWithEmployeesText() {
            if (this.total_companies == 1)
                return (
                    this.total_companies +
                    " company with " +
                    this.total_employees +
                    " employees"
                );

            return (
                this.total_companies +
                " companies with " +
                this.total_employees +
                " employees"
            );
        }
    },

    methods: {
        async getTotalCompaniesAndEmployees() {
          const data = await axios
          .get("/company/total-companies-employees")
          .then(data => data.data.data);

          this.total_companies = data["total_companies"];
          this.total_employees = data["total_employees"];
        },

        viewCompanyDetails(companyId) {
            this.$emit("viewCompanyDetails", companyId);
        }
    },

    mounted() {
        this.getTotalCompaniesAndEmployees();
    }
};
</script>
